// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2496":"428e54ce","5646":"df6471ed","6176":"507ab76d","6903":"64995117","7891":"07ca948e"}[chunkId] + ".chunk.css";
};